import React, { useState, useEffect } from "react";
import { BiSolidChevronDown } from "react-icons/bi";
import { Popover, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchInvestor } from "../../store/Slices/InvestorSlice";

const InvestorSelector = ({ SelectedInvestor, setSelectedInvestor }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [SearchText, setSearchText] = useState("");
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    console.log("Closing popover...");
    setAnchorEl(null); // ✅ Ensures popover closes
  };
  const open = Boolean(anchorEl);
  const id = open ? "my-popover" : undefined;

  const dispatch = useDispatch();
  const Investors = useSelector((state) => state.Investors);

  useEffect(() => {
    dispatch(fetchInvestor());
  }, [dispatch]);

  return (
    <div className="flex flex-col px-0 gap-y-4">
      <div
        // className="px-4 py-[6px] border-2 border-white rounded-full cursor-pointer bg-[#465462] text-white"
        className={`relative text-left cursor-pointer transition-colors ease-in-out duration-200 border border-line hover:border-main bg-card text-ink px-4 py-3 rounded-lg font-quicksand font-bold text-sm flex gap-x-6 items-center active:scale-[.99]`}
        onClick={handleClick}
      >
        <div className="flex items-center justify-between w-full">
          <div className="w-full outline-none text-left bg-transparent">
            {SelectedInvestor === ""
              ? "Select Investor"
              : SelectedInvestor?.name}
          </div>
          <BiSolidChevronDown
            className="text-[1.5rem] cursor-pointer text-muted"
            aria-describedby={id}
            variant="contained"
          />
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            backgroundColor: "#ffffff",
            border: "1px solid #E5E9EB",
            width: "100%", // Set the width as needed
            maxWidth: "300px",
            overflow: "hidden", // Hide overflowing content
            marginTop: "10px",
            boxShadow: "0 10px 30px rgba(16,69,70,0.12), 0 2px 8px rgba(16,69,70,0.08)",
            overflowY: "auto",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Typography
          sx={{
            p: 2,
            backgroundColor: "#ffffff",
            overflow: "hidden",
            borderRadius: "12px",
          }}
        >
          <div className="bg-card text-ink font-quicksand flex flex-col justify-center items-center rounded-lg">
            <div className="w-full flex flex-col justify-between gap-y-3 items-start">
              <input
                type="text"
                placeholder="Search"
                name=""
                className="w-full px-3 py-1 rounded-xl text-ink"
                id=""
                value={SearchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              {Investors.data &&
                Investors.data
                  .filter((investor) => {
                    if (SearchText === "") {
                      return investor;
                    } else if (
                      investor.name
                        .toLowerCase()
                        .includes(SearchText.toLowerCase())
                    ) {
                      return investor;
                    }
                    return false;
                  })
                  .map((investor, i) => {
                    return (
                      <div
                        className="flex gap-x-3 items-center cursor-pointer hover:bg-subtle rounded-lg px-2 py-1 transition-colors"
                        onClick={() => {
                          setSelectedInvestor(investor);
                          handleClose();
                        }}
                      >
                        <input
                          type="checkbox"
                          className="mr-1 h-4 w-4 rounded border border-line accent-main"
                          checked={SelectedInvestor._id === investor._id}
                          readOnly
                          onChange={() => {}} // Empty onChange to prevent warning
                        />
                        <span>{investor.name}</span>
                      </div>
                    );
                  })}
            </div>
          </div>
        </Typography>
      </Popover>
    </div>
  );
};

export default InvestorSelector;
